import React from 'react';
import './header.scss'

const Header = () => {
	return (
		<div className="header">
			<h1 className="name">Get Healthy</h1>
		</div>
	);
}
 
export default Header;